export default "__VITE_ASSET__qgHz$nfp__"